export default __webpack_public_path__ + "static/lalibrairie-m-desktop@2x-b44317ffd1d2b4593eb0ec6a52408375.jpg";